module.exports = "<div class=row> <form class=\"col s12\"> <div class=row> <text-area class=\"col s12\" label=textarea value=\"this is the text content\" icon=mode_edit></text-area> </div> </form> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/forms/text-area-demo.vue
 ** module id = 273
 ** module chunks = 0
 **/